import { render, staticRenderFns } from "./AcquisitionFormProgress.vue?vue&type=template&id=956b478c&scoped=true&"
import script from "./AcquisitionFormProgress.vue?vue&type=script&lang=js&"
export * from "./AcquisitionFormProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956b478c",
  null
  
)

export default component.exports